import { render, staticRenderFns } from "./customSortModal.vue?vue&type=template&id=ea03dd22&scoped=true"
import script from "./customSortModal.vue?vue&type=script&setup=true&lang=js"
export * from "./customSortModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./customSortModal.vue?vue&type=style&index=0&id=ea03dd22&prod&lang=scss"
import style1 from "./customSortModal.vue?vue&type=style&index=1&id=ea03dd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea03dd22",
  null
  
)

export default component.exports